import { Injectable, Injector } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadModalComponent } from './upload-modal.component';
import { UploadProductsModalParams } from './upload-products-modal-params';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'any',
})
export class UploadModalService {
  modalResult$: Subject<null> = new Subject();

  constructor(private modalService: NgbModal) {}

  openModal(modalParams: UploadProductsModalParams) {
    const uploadModal = this.modalService.open(UploadModalComponent, {
      size: modalParams.modalSize ?? 'lg',
      backdrop: 'static',
      windowClass: modalParams.windowClass,
    });

    uploadModal.componentInstance.modalParams$.next(modalParams);

    uploadModal.result.then(
      () => {
        this.modalResult$.next(null);
      },
      () => {},
    );

    return uploadModal;
  }
}
